import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4e1af11d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "user-manage-container"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_3 = {
  class: "flex align-center"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, "审批的事项类型：", -1));
const _hoisted_5 = {
  style: {
    "width": "300px"
  }
};
const _hoisted_6 = {
  style: {
    "margin-left": "20px"
  }
};
import { delUserApproval, getUserApprovalList } from '@/api/user';
import { ElMessage, ElMessageBox } from 'element-plus';
import { ref, onMounted } from 'vue';
import Table from './components/table.vue';
import { TYPE_OPTIONS } from './config';
import { Search, Refresh } from '@element-plus/icons-vue';
import AddDialog from './components/add';
export default {
  __name: 'index',
  setup(__props) {
    const type = ref('');
    const auditorName = ref('');

    // 数据相关
    const tableData = ref([]);
    const total = ref(0);
    const page = ref(1);
    const size = ref(8);
    const loading = ref(false);
    // 获取数据的方法
    const getListData = async () => {
      loading.value = true;
      const result = await getUserApprovalList({
        currentPage: page.value,
        pageSize: size.value,
        type: type.value,
        auditorName: auditorName.value
      });
      tableData.value = result.records;
      total.value = result.total;
      loading.value = false;
    };
    onMounted(() => {
      getListData();
    });
    const handleRefresh = async () => {
      type.value = '';
      page.value = 1;
      auditorName.value = '';
      await getListData();
    };
    const handleCurrentChange = val => {
      page.value = val;
      getListData();
    };
    const dialogVisible = ref(false);
    const addUserHandler = () => {
      dialogVisible.value = true;
    };
    const current = ref(null);
    const handleUpdateUser = row => {
      current.value = row;
      dialogVisible.value = true;
    };
    const delUserHandler = row => {
      ElMessageBox.confirm('确认要删除吗', {
        type: 'warning'
      }).then(async () => {
        try {
          await delUserApproval(row.id);
          ElMessage.success('删除成功');
          // 重新渲染数据
          getListData();
        } catch (error) {
          ElMessage({
            message: error,
            type: 'error'
          });
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "header",
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
          modelValue: auditorName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => auditorName.value = $event),
          placeholder: "请输入审批人姓名",
          style: {
            "width": "300px",
            "margin-right": "20px"
          }
        }, null, 8, ["modelValue"]), _hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_select, {
          modelValue: type.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => type.value = $event),
          class: "m-2",
          placeholder: "选择审批的事项类型"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(TYPE_OPTIONS), item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_button, {
          type: "primary",
          icon: _unref(Search),
          onClick: getListData
        }, {
          default: _withCtx(() => [_createTextVNode(" 查询 ")]),
          _: 1
        }, 8, ["icon"]), _createVNode(_component_el_button, {
          icon: _unref(Refresh),
          onClick: handleRefresh
        }, {
          default: _withCtx(() => [_createTextVNode(" 重置 ")]),
          _: 1
        }, 8, ["icon"])])]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          onClick: addUserHandler
        }, {
          default: _withCtx(() => [_createTextVNode(" 新增 ")]),
          _: 1
        })), [[_directive_permission, ['userAdd']]])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_createVNode(Table, {
          data: tableData.value,
          page: page.value,
          size: size.value,
          total: total.value,
          onDelUserHandler: delUserHandler,
          onHandleCurrentChange: handleCurrentChange,
          onUpdateUserHandler: handleUpdateUser,
          loading: loading.value
        }, null, 8, ["data", "page", "size", "total", "loading"])]),
        _: 1
      }), _createVNode(_unref(AddDialog), {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogVisible.value = $event),
        onGetData: getListData,
        model: current.value,
        onClearModel: _cache[3] || (_cache[3] = $event => current.value = null)
      }, null, 8, ["modelValue", "model"])]);
    };
  }
};